import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import toast from '@helpers/toast';

import { deleteLocationApi, fetchLocationsApi, saveLocationApi } from './locations.api';
import {
  deleteLocationFailure,
  deleteLocationRequest,
  deleteLocationSuccess,
  fetchLocationsFailure,
  fetchLocationsRequest,
  fetchLocationsSuccess,
  saveLocationFailure,
  saveLocationRequest,
  saveLocationSuccess,
} from './locations.slice';

import { LocationInterface } from '@stone/interfaces';
import { handleSagaError } from '@stone/sagaHelpers';

function* fetchLocationsSaga(action: PayloadAction<any>): Generator<any, void, any> {
  try {
    const response: { items: LocationInterface[]; totalCount: number } = yield call(fetchLocationsApi, action.payload);
    yield put(fetchLocationsSuccess(response));
  } catch (error: any) {
    yield handleSagaError(error, fetchLocationsFailure, 'Failed to load locations');
  }
}

function* saveLocationSaga(action: PayloadAction<LocationInterface>): Generator<any, void, any> {
  try {
    yield call(saveLocationApi, action.payload);
    yield put(saveLocationSuccess());
    toast.success('Location saved successfully');
    yield put(fetchLocationsRequest({ searchCriteria: { pageSize: 20, currentPage: 1 } }));
  } catch (error: any) {
    yield handleSagaError(error, saveLocationFailure, 'Failed to save location');
  }
}

function* deleteLocationSaga(action: PayloadAction<number>): Generator<any, void, any> {
  try {
    yield call(deleteLocationApi, action.payload);
    yield put(deleteLocationSuccess());
    toast.success('Location deleted successfully');
    yield put(fetchLocationsRequest({ searchCriteria: { pageSize: 20, currentPage: 1 } }));
  } catch (error: any) {
    yield handleSagaError(error, deleteLocationFailure, 'Failed to delete location');
  }
}

export default function* locationsSaga() {
  yield takeLatest(fetchLocationsRequest.type, fetchLocationsSaga);
  yield takeLatest(saveLocationRequest.type, saveLocationSaga);
  yield takeLatest(deleteLocationRequest.type, deleteLocationSaga);
}
